module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag42_1998AT.ef8ea892.jpg";